import type { GameScenario } from "./types";

export const policeScenarios: GameScenario[] = [
  {
    id: 1,
    title: "콜센터 증거 확보 및 분석 (초동 대응)",
    situation:
      "[메시지 폭탄 해독!] 비밀 파일 속 단서를 해독해 보스의 다음 작전과 암호를 해독해라!",
    choices: [
      {
        text: "타이핑된 기록을 하나씩 보며 중요한 단어 직접 찾기!",
        result:
          "[증거 확인!] 증거 분석에 10시간이 걸려요. 그 사이에 총책은 이미 도망가기 시작했어요! 🚨",
        video: {
          selection: "./videos/police-mission/경찰 미션1_선택1.mp4",
          result: "./videos/police-mission/경찰 미션1_선택1_결과.mp4",
        },
        isOptimal: false,
        next: 1,
      },
      {
        text: "대규모 언어 모델에게 맡겨 모든 음성 기록을 5줄로 요약 받기!",
        result:
          "[초스피드 성공!] AI가 10분 만에 총책의 도주 계획을 찾아냈어요! 도망가기 전에 다음 단계로 갑시다!",
        video: {
          selection: "./videos/police-mission/경찰 미션1_선택2.mp4",
          result: "./videos/police-mission/경찰 미션1_선택2_결과.mp4",
        },
        isOptimal: true,
        next: 1,
      },
    ],
  },
  {
    id: 2,
    title: "총책의 도주 경로 파악 (위치 추적)",
    situation:
      "[도주 경로 미로 찾기!] 보스가 여기저기 뿌려놓은 위치 데이터 파편을 합쳐서 범인의 최종 도주 경로를 완성하자!",
    choices: [
      {
        text: "경험을 믿고 가장 유력한 1개의 길만 따라가 추적하기!",
        result:
          "[경로 파악!] 정보가 너무 복잡하지만, 밤샘 근무로 경로를 예상했어요. 하지만 총책이 골목길로 빠지면서 추적팀을 따돌렸어요!",
        video: {
          selection: "./videos/police-mission/경찰 미션2_선택1.mp4",
          result: "./videos/police-mission/경찰 미션2_선택1_결과.mp4",
        },
        isOptimal: false,
        next: 2,
      },
      {
        text: "수백 개 데이터를 분석하여 가장 확실한 3D 도주 경로 지도 받기!",
        result:
          "[경로 수색!] 총책의 경로를 AI가 예측한 5개 경로 중 2개를 선택하였습니다. 2개의 경로에 집중 수색을 시작할꺼에요!",
        video: {
          selection: "./videos/police-mission/경찰 미션2_선택2.mp4",
          result: "./videos/police-mission/경찰 미션2_선택2_결과.mp4",
        },
        isOptimal: true,
        next: 2,
      },
    ],
  },
  {
    id: 3,
    title: "숨겨진 디지털 자산 추적 (범죄 수익 환수)",
    situation:
      "[블랙 머니 금고 해킹!] 보스가 숨긴 '검은 돈'(암호화페) 을 추적해 피해자들에게 돌려주자!",
    choices: [
      {
        text: "'수많은 거래 목록을 처음부터 끝까지 하나씩 검색하기!",
        result:
          "[돈이 사라짐!] 돈의 흐름이 너무 복잡해서 추적에 실패했어요. 총책이 돈을 해외로 빼돌려 피해액의 10%밖에 못 찾았어요. 😢",
        video: {
          selection: "./videos/police-mission/경찰 미션3_선택1.mp4",
          result: "./videos/police-mission/경찰 미션3_선택1_결과.mp4",
        },
        isOptimal: false,
        next: 3,
      },
      {
        text: "모든 돈의 흐름을 분석해 수상한 거래를 확률로 예측하기!",
        result:
          "[돈 찾기 성공!] AI가 돈이 빠져나가기 직전에 비밀 지갑을 잠가버렸어요! 피해액의 95%를 되찾아 피해자들에게 돌려줄 수 있게 되었어요",
        video: {
          selection: "./videos/police-mission/경찰 미션3_선택2.mp4",
          result: "./videos/police-mission/경찰 미션3_선택2_결과.mp4",
        },
        isOptimal: true,
        next: 3,
      },
    ],
  },
  {
    id: 4,
    title: "현장 상황 파악 및 인명 위험 예측 (작전 투입 전)",
    situation:
      "[현장 침투! 위험 등급 측정!] 악당이 총을 들었나? 현장 위험 실시간 측정! 안전한 진입로를 확보하자!",
    choices: [
      {
        text: "CCTV 화면을 확대하여 위험 물품의 여부만 확인하기!",
        result:
          "[위험 감수!] CCTV 화질이 안 좋아서 총책이 위험한 물건을 들고 있는지 확인이 늦어졌어요. 안전 때문에 작전이 10분 늦어졌어요.",
        video: {
          selection: "./videos/police-mission/경찰 미션4_선택1.mp4",
          result: "./videos/police-mission/경찰 미션4_선택1_결과.mp4",
        },
        isOptimal: false,
        next: 4,
      },
      {
        text: "실시간 드론 분석 시스템으로 영상 분석 맡겨 AR 진입 경로 받기!",
        result:
          "[안전한 진입!] AI가 총책의 손에 있는 물건이 무기가 아닌 휴대폰임을 확인했어요! 대원들이 즉시 움직여 용의자를 포위했어요.",
        video: {
          selection: "./videos/police-mission/경찰 미션4_선택2.mp4",
          result: "./videos/police-mission/경찰 미션4_선택2_결과.mp4",
        },
        isOptimal: true,
        next: 4,
      },
    ],
  },
  {
    id: 5,
    title: "최종 의사 결정 및 검거 (범인 검거)",
    situation:
      "[파이널 미션!] 1초의 오차도 금물! 증거 인멸 전 완벽 타이밍을 잡아라!",
    choices: [
      {
        text: "경험을 믿고 지금 바로 돌격하여 범인 체포하기!",
        result:
          "[아쉬운 결과!] 예상치 못한 곳에서 총책이 증거를 없애는 장치를 작동시켰어요! 체포는 했지만 중요한 증거 일부가 사라졌어요. 재판이 어려워질 수도 있어요.",
        video: {
          selection: "./videos/police-mission/경찰 미션5_선택1.mp4",
          result: "./videos/police-mission/경찰 미션5_선택1_결과.mp4",
        },
        isOptimal: false,
        next: -1,
      },
      {
        text: "작전 시뮬레이터로 가장 완벽한 체포 타이밍을 분석하기!",
        result:
          "[미래 수사 성공!] AI가 '총책이 1분 안에 증거인멸 장치를 작동시키는 확률 75%'라고 예측했어요. 60초 안에 진입하여 총책이 증거를 없애기 전에 체포했어요.",
        video: {
          selection: "./videos/police-mission/경찰 미션5_선택2.mp4",
          result: "./videos/police-mission/경찰 미션5_선택2_결과.mp4",
        },
        isOptimal: true,
        next: -1,
      },
    ],
  },
];
